import ReportSectionContent from "../../../components/UI/ReportSectionContent";
import { examCardEnums } from "../../../enums";
import EyeReport from "./EyeReport";

const ContrastSensitivityReport = () => {
  return (
    <ReportSectionContent
      sectionName={examCardEnums.CONTRAST_SENSITIVITY.sectionName}
      EyeReport={<EyeReport />}
    />
  );
};

export default ContrastSensitivityReport;
